import "core-js/modules/es.array.reduce.js";
import React, { cloneElement } from 'react';
var replacements = [// triple prime
[/'''/g, function (retainLength) {
  return "\u2034" + (retainLength ? "\u2063\u2063" : '');
}], // beginning "
[/(\W|^)"(\w)/g, "$1\u201C$2"], // ending "
[/(\u201c[^"]*)"([^"]*$|[^\u201c"]*\u201c)/g, "$1\u201D$2"], // remaining " at end of word
[/([^0-9])"/g, "$1\u201D"], // double prime as two single quotes
[/''/g, function (retainLength) {
  return "\u2033" + (retainLength ? "\u2063" : '');
}], // beginning '
[/(\W|^)'(\S)/g, "$1\u2018$2"], // conjunction's possession
[/([a-z])'([a-z])/ig, "$1\u2019$2"], // abbrev. years like '93
[/(\u2018)([0-9]{2}[^\u2019]*)(\u2018([^0-9]|$)|$|\u2019[a-z])/ig, "\u2019$2$3"], // ending '
[/((\u2018[^']*)|[a-z])'([^0-9]|$)/ig, "$1\u2019$3"], // backwards apostrophe
[/(\B|^)\u2018(?=([^\u2018\u2019]*\u2019\b)*([^\u2018\u2019]*\B\W[\u2018\u2019]\b|[^\u2018\u2019]*$))/ig, "$1\u2019"], // double prime
[/"/g, "\u2033"], // prime
[/'/g, "\u2032"]]; // @ts-ignore

var replacements$1 = replacements.filter(function (_a) {
  var _ = _a[0],
      substitution = _a[1];
  if (typeof substitution === 'function') return substitution(true);
  return substitution;
});
/**
 * Based on:
 * https://practicaltypography.com/straight-and-curly-quotes.html
 */

var curlyq = function curlyq(value) {
  if (value === void 0) {
    value = '';
  }

  return replacements$1.reduce(function (accumulator, _a) {
    var pattern = _a[0],
        substitution = _a[1];
    return accumulator.replace(pattern, substitution);
  }, value);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

var Children = React.Children,
    isValidElement = React.isValidElement;

var recursivelyWalkChildren = function recursivelyWalkChildren(children, fn) {
  return Children.map(children, function (child) {
    var _a;

    if (!isValidElement(child)) return fn(child);
    var props = (_a = child.props) !== null && _a !== void 0 ? _a : {};
    if (!props.children) return child;
    return cloneElement(child, _assign(_assign({}, props), {
      children: recursivelyWalkChildren(props.children, fn)
    }));
  });
};

var CurlyQ = function CurlyQ(_a) {
  var children = _a.children;
  return recursivelyWalkChildren(children, function (child) {
    return curlyq(child.toString());
  });
};

export { CurlyQ, curlyq };